import { usePostHog } from '@/composables/usePostHog'
import { createRouter, createWebHistory } from 'vue-router'
import store from './store'
import Login from './components/Login.vue'
import ForgotPassword from './components/ForgotPassword.vue'
import PasswordReset from './components/PasswordReset.vue'
import Signup from './components/Signup.vue'
import ConfirmEmailSent from './components/ConfirmEmailSent.vue'
import ConfirmEmail from './components/ConfirmEmail.vue'
import ApproveUser from './components/ApproveUser.vue'
import Dashboard from './pages/Dashboard.vue'
import Profile from './pages/Profile.vue'
import NotFound from "./components/NotFound.vue"
import Settings from "./pages/Settings.vue"
import AeoAnalytics from './pages/AeoAnalytics.vue'
import Prompts from './pages/Prompts.vue'

const routes = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/analytics',
    name: 'AeoAnalytics',
    component: AeoAnalytics,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/analytics/findings/:findingId',
    redirect: (to) => ({
      path: '/analytics',
      query: {
        ...to.query,
        finding_id: to.params.findingId,
        tab: to.query.tab || 'action_center'
      }
    })
  },
  {
    path: '/analytics/findings/:findingId/solution',
    redirect: (to) => ({
      path: '/analytics',
      query: {
        ...to.query,
        finding_id: to.params.findingId,
        step: 'solution',
        tab: to.query.tab || 'action_center'
      }
    })
  },
  {
    path: '/prompts',
    name: 'Prompts',
    component: Prompts,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup
  },
  {
    path: '/confirm-email-sent',
    name: 'ConfirmEmailSent',
    component: ConfirmEmailSent,
    meta: { requiresAuth: false }
  },
  {
    path: '/confirm-email',
    name: 'ConfirmEmail',
    component: ConfirmEmail,
    meta: { requiresAuth: false }
  },
  {
    // Linked from the "New user signed up" email; the signed token authorizes it
    path: '/approve-user',
    name: 'ApproveUser',
    component: ApproveUser,
    meta: { requiresAuth: false }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/forgotPassword',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/passwordReset',
    name: 'PasswordReset',
    component: PasswordReset
  },
  { 
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { 
      requiresAuth: true,
     }  
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: { 
      requiresAuth: true,
     }  
  },
  {
    path: "/:catchAll(.*)",
    name: 'NotFound',
    component: NotFound
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('auth_token');

  if (to.meta.requiresAuth === true && !token) {
    next('/login');
    return;
  }

  if (to.meta.requiresAdmin === true) {
    if (!store.getters.isAdmin) {
      try {
        if (token) {
          await store.dispatch('loginUserWithToken', { auth_token: token });
        }
      } catch (error) {
        console.error('Failed to refresh user before admin route check:', error);
      }
      if (!store.getters.isAdmin) {
        next('/dashboard');
        return;
      }
    }
  }

  next();
});

const { posthog } = usePostHog()

export default router